module.exports = __webpack_public_path__ + "templates.product_review_comments_form-4230a4cf.html";